module.exports = __webpack_public_path__ + "static/media/pdf.23a43a35.svg";